module.exports = __webpack_public_path__ + "static/servicios-digitales-2e73aff3a930b866a2505a2ae338c0d2.svg";